export function formatTextWithLineBreaks(text: string) {
  return text.replace(/\n/g, '<br />');
}
